function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.54 1.88c-1.23 0-2.23 1-2.23 2.23v4.64c0 1.23 1 2.23 2.23 2.23s2.23-1 2.23-2.23V4.11c0-1.22-1-2.23-2.23-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M20.18 7.11c-1.07 0-1.94.87-1.94 1.94v1.57c0 .21.17.38.38.38h1.57c1.07 0 1.94-.87 1.94-1.94 0-1.07-.88-1.95-1.95-1.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 6.99H3.86c-1.23 0-2.23 1-2.23 2.23s1 2.23 2.23 2.23H8.5c1.23 0 2.23-1 2.23-2.23s-1-2.23-2.23-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8.79 1.62c-1.07 0-1.94.87-1.94 1.94 0 1.07.87 1.94 1.94 1.94h1.57c.21 0 .38-.17.38-.38V3.55a1.962 1.962 0 00-1.95-1.93z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.43 13.03c-1.23 0-2.23 1-2.23 2.23v4.64c0 1.23 1 2.23 2.23 2.23s2.23-1 2.23-2.23v-4.64c0-1.23-1-2.23-2.23-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M5.36 13.03H3.79c-1.07 0-1.94.87-1.94 1.94 0 1.07.87 1.94 1.94 1.94 1.07 0 1.94-.87 1.94-1.94V13.4c0-.2-.17-.37-.37-.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.11 12.57h-4.64c-1.23 0-2.23 1-2.23 2.23s1 2.23 2.23 2.23h4.64c1.23 0 2.23-1 2.23-2.23s-1-2.23-2.23-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.18 18.47h-1.57a.38.38 0 00-.38.38v1.57c0 1.07.87 1.94 1.94 1.94 1.07 0 1.94-.87 1.94-1.94a1.93 1.93 0 00-1.93-1.95z"
})));